import { render, staticRenderFns } from "./AllFilesModal.vue?vue&type=template&id=6474ba3c&scoped=true&"
import script from "./AllFilesModal.vue?vue&type=script&lang=js&"
export * from "./AllFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./AllFilesModal.vue?vue&type=style&index=0&id=6474ba3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474ba3c",
  null
  
)

export default component.exports